import {connect} from 'react-redux';

import {
  ConversationCardContainerBaseProps,
  makeGetTags,
} from '../../../../srcCommon/inboxes/contactDetails/conversationsHistorySelectors';
import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {ConversationCardTags} from './conversationCardTags';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ConversationCardContainerBaseProps>()(() => ({
  tags: makeGetTags(),
}));

export const ConversationCardTagsContainer = connect(mapStateToProps)(ConversationCardTags);
